module.exports = __webpack_public_path__ + "img/wzf_10.8515bfa5.png";